import React from 'react';
import Tabs from './Tabs';

function Staff() {
    return <Tabs />;
}

export default React.memo(Staff);
